<template>
  <el-form :model="form" ref="form" label-position="top">
    <el-row>
      <el-col :span="12">
        <el-form-item label="临时目录" prop="tempdir">
          <el-input v-model="form.tempdir"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="默认后缀" prop="fileext">
          <el-input v-model="form.fileext"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="阈值" prop="threshold">
          <el-input-number v-model="form.threshold"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否自动命名" prop="autoname">
          <el-switch
            v-model="form.autoname"
            active-text="开"
            inactive-text="关">
          </el-switch>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>

  import rApi from "@/api/senior/seniorconf";
  let datafault = {
  };
  export default {
    components: { rApi },
    props: {
      uuid:""
    },
    data() {
      return {
        form:{
          tempdir:"",
          fileext:"",
          threshold:100000,
          autoname:false
        }
      };
    },
    mounted() {
      if(this.uuid){
        rApi.getPdSenior(this.uuid).then(resp=>{
          var _form = JSON.parse(resp.data);
          this.form.tempdir = _form.tempdir?_form.tempdir:this.form.tempdir;
          this.form.fileext = _form.fileext?_form.fileext:this.form.fileext;
          this.form.autoname = _form.autoname||_form.autoname===false?_form.autoname:this.form.autoname;
          this.form.threshold = _form.threshold?_form.threshold:this.form.threshold;
        });
      }
    },
    methods: {
      save(){
        if(this.uuid){
          rApi.doSaveForPdSenior(this.uuid,JSON.stringify(this.form)).then(()=>this.$message.success("操作成功！"));
        }
        return this.form;
      }
    }
  };
</script>
<style scoped>
</style>